import { createSlice } from "@reduxjs/toolkit";

import { LOCAL_STORAGE_KEYS } from "shared/constants/storageKeys";

import { setLocalStorageData } from "shared/helpers/view";

const initialState = {
  prev: [],
  current: null,
  isFromCache: false,
};

const routeSlice = createSlice({
  name: "route",
  initialState,
  reducers: {
    updateRout: (state, { payload }) => {
      state.prev = state.current ? [...state.prev, state.current] : [];
      state.current = payload;
    },
    backRout: (state, { payload }) => {
      state.prev.pop();
      state.prev = state.current ? [...state.prev] : [];
      state.current = payload;
    },
    setRout: (state, { payload }) => {
      state.prev = [...payload.prev];
      state.current = payload.current;
      if (payload.isFromCache) {
        state.isFromCache = payload.isFromCache;
      }
    },
    clearRout: (state, { payload }) => {
      state.prev = [];
      state.current = payload;
      state.isFromCache = false;
    },
  },
});

export const { updateRout, backRout, setRout, clearRout } = routeSlice.actions;

export const updateRouteData = (data) => async (dispatch, getState) => {
  dispatch(updateRout(data));
  const { route } = getState();
  setLocalStorageData(LOCAL_STORAGE_KEYS.LOCATION_DATA, {
    current: route.current,
    prev: [...route.prev],
  });
};

export const backRouteData = (data) => async (dispatch, getState) => {
  dispatch(backRout(data));
  const { route } = getState();
  setLocalStorageData(LOCAL_STORAGE_KEYS.LOCATION_DATA, {
    current: route.current,
    prev: [...route.prev],
  });
};

export const clearRouteData = (data) => async (dispatch, getState) => {
  dispatch(clearRout(data));
  const { route } = getState();
  setLocalStorageData(LOCAL_STORAGE_KEYS.LOCATION_DATA, {
    current: route.current,
    prev: [...route.prev],
  });
};

export default routeSlice.reducer;
